import { useQuery } from "@tanstack/react-query";
import { RequestOrderFormSelectedOptions } from "hooks/api/requestOrder";
import useSelectedContractDocEntry from "hooks/useSelectedContractDocEntry";
import {
  getContractOrderRequestQueryOptions,
  mapDimCodeNameToSelectOption,
} from "./getContractOrderRequestQueryOptions";

const useGetContractOrderRequestShipTos = ({
  shipTo,
  shipFrom,
  salesTerms,
  mode,
}: RequestOrderFormSelectedOptions) => {
  const selectedContractDocEntry = useSelectedContractDocEntry();
  return useQuery({
    ...getContractOrderRequestQueryOptions(selectedContractDocEntry, {
      modeOfTransportationCode: mode?.value,
      warehouseCode: shipFrom?.value,
      salesTermsCode: salesTerms?.value,
    }),
    enabled: !!selectedContractDocEntry && !shipTo,
    keepPreviousData: !!shipTo,
    select: ({ data }) =>
      data?.ShipToAddresses?.map(mapDimCodeNameToSelectOption),
  });
};

export default useGetContractOrderRequestShipTos;
